import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import geocode from '../app/geocode';
import AddressesForm from './addresses/addresses_form';

function updateCoordinates($el, i, lat, lng) {
  $el.find(`#student_addresses_attributes_${i}_lat`).val(lat);
  $el.find(`#student_addresses_attributes_${i}_lng`).val(lng);
  $el.find('input.student-address-coordinates').val(`${lat}, ${lng}`);
}

function setupCards() {
  _.forEach(_.range(0, 4), (i) => {
    const selector = _.map(['street', 'npa', 'city'],
      value => `#student_addresses_attributes_${i}_${value}`).join(', ');
    $(selector).off('change').on('change', () => {
      const $inputs = $(selector);
      const $row = $inputs.parents('.row');
      updateCoordinates($row, i, '', '');
      geocode(..._.map($inputs, 'value')).then(({ lat, lng }) => {
        updateCoordinates($row, i, lat, lng);
      }).catchReturn();
    });

    _({
      student_id_preview: '#student_id',
      student_first_name_preview: '#student_first_name',
      student_last_name_preview: '#student_last_name',
      student_birthday_preview: '#student_birthday',
      student_validity_start_preview: '#student_validity_start',
      student_validity_end_preview: '#student_validity_end',
      student_address_street_preview: '#student_addresses_attributes_0_street',
      student_address_npa_preview: '#student_addresses_attributes_0_npa',
      student_address_city_preview: '#student_addresses_attributes_0_city',
    }).forIn((value, key) => {
      $(value).off('keyup dp.change').on('keyup dp.change', e => $(`#${key}`).text(e.currentTarget.value));
    });
    $('#image_student_photo').on('load', (e) => {
      $('#student_photo_preview').attr('src', e.currentTarget.src);
    });
  });
}

function setupAddressesForm() {
  const $container = $('#student-address-rows');
  if (!$container.length) { return; }
  ReactDOM.render(<AddressesForm addresses={$container.data('addresses')} />, $container[0]);
}

$(document).on('ready turbolinks:load', () => {
  setupCards();
  setupAddressesForm();
});
